import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators }   from 'redux';
import {
    isSubmissionRepositionExp,
    JEWELRY_FOR_EXPERIMENTS,
    rootUrl,
    submissionFlowUrl,
} from 'helpers/ApplicationHelper';


import I18n from 'lib/i18n/i18n';

import PopupHelp from 'components/popups/popupHelp';

import {updateSubmissionProgressState} from 'actions/submissionProgress';

class EstimationFailed extends Component {
    constructor(props) {
        super(props);

        this._onHelp = this._onHelp.bind(this);
    }

    //upgrade change
    componentDidMount() {
        this.props.updateSubmissionProgressState('no estimation');
    }

    componentWillUnmount() {
        this.props.updateSubmissionProgressState();
    }

    _onHelp(event) {
        event.preventDefault();
        PopupHelp.initPopup({single: true, modal: true});
    }

    render(){
        const { Item } = this.props;

        //No, thanks, go back to <Link to={`/`}>home</Link>.
        const underMinimum = Item.under_minimum_estimation;
        const showTitle = underMinimum ? I18n.getString('itemPage::estimationFailed::underMinimumTitle') !== '' : true;

        const isNewSubmissionFlowExp = isSubmissionRepositionExp();
        const isRing = Item.item_type === JEWELRY_FOR_EXPERIMENTS[1]; // Stands for "ring"

        const reSubmitUrl = isNewSubmissionFlowExp && isRing ? submissionFlowUrl() : `/submit/${Item.item_type}`;

        return (
            <div id="item-state-estimation-failed">
                <div className="item-state-estimation-failed-container">
                    <h1 className={showTitle ? 'show' : 'hide'}>{underMinimum ? I18n.getString('itemPage::estimationFailed::underMinimumTitle') : I18n.getString('itemPage::estimationFailed::title') }</h1>
                    <p className={underMinimum ? 'hide' : 'show'}>
                        {I18n.getString('itemPage::estimationFailed::text1')}
                    </p>
                    <p className={underMinimum ? 'show' : 'hide'}>
                        {I18n.getJsx('itemPage::estimationFailed::underMinimumText', {
                            item_type_first: <span>{Item.item_type}</span>
                        })}
                    </p>
                    <a href={reSubmitUrl} className="submit-new-item">
                        <button type="submit" className="btn btn-gold">
                            <span>{I18n.getString('itemPage::estimationFailed::submitNewItem')}</span>
                        </button>
                    </a>
                    <p className="phone-number-desktop">
                        <span>{I18n.getString('itemPage::estimationFailed::needHelp::desktop')}</span>
                        <span className="phone-number"><b>{I18n.getString('common::phoneNumberString')}</b></span>
                    </p>
                </div>
                <div className="bottom-text mobile">
                    <div className="call-us">
                        <span>{I18n.getString('itemPage::estimationFailed::needHelp::mobile')}</span>
                        <a href={`tel:${I18n.getString('common::phoneNumber')}`} className="call-us-button"><span>{I18n.getString('common::phoneNumberString')}</span></a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        Item: state.Item
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({updateSubmissionProgressState}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EstimationFailed);
